<template>
  <lu-vbox lu-flex class='tab-container' style='height: 100%'>
    <Spinner ref='spinner' style='z-index:60000 !important'/>

    <el-form label-position="right"  style='flex: 1 1 auto; display: flex;' ref="form" :model='form' lu-flex label-width="110px">
      <lu-vbox lu-flex >
      <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>
        <lu-vbox lu-flex style='padding: 30px;'>
          <lu-hbox lu-hright class='pad-in-5' >
            <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='save'>{{ $t('save') }}</el-button></lu-item>
          </lu-hbox>
          <lu-vbox lu-flex style='margin-top:20px;' class='vpad-in-5'>
            <el-table
              class='table'
              :data="form.parameterList"
              fit
              striped
              style="width: 100%; margin-top:10px;"
              :default-sort = "{prop: 'id', order: 'ascending'}"
              :row-class-name="tableRowClassName"
              :show-header="false"
            >
                <el-table-column :label="$t('Target')" prop='brokerPtfName' align="left" min-width="50">
                  <template slot-scope="scope">
                    <span>{{ scope.row.brokerPtfName }}</span>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('Type')" prop='paramName' align="left" min-width="50">
                  <template slot-scope="scope">
                    <span>{{ scope.row.paramName }}</span>
                  </template>
                </el-table-column>

                <el-table-column align="center" :label="$t('Parameter')" prop="paramValue" min-width="150">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.paramValue" autosize type="textarea"></el-input>
                  </template>
                </el-table-column>
            </el-table>
          </lu-vbox>
        </lu-vbox>
      </lu-scroll-area>
      </lu-vbox>
    </el-form>
  </lu-vbox>
</template>

<script>
import { LuHbox, LuItem, LuVbox, LuScrollArea } from 'lusis-ui'
import { mapGetters } from 'vuex'
import Spinner from '@/components/Spinner'

export default {
  name: 'CreditControlConfig',
  components: { Spinner, LuHbox, LuItem, LuVbox, LuScrollArea },
  data () {
    return {
      forceLoading: false,
      parameterList: [],
      form: {
        parameterList: []
      }
    }
  },
  methods: {
    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'odd-row';
      } else {
        return 'even-row';
      }
    },
    makeDiff (server, client, comp, diff) {
      let arr = []
      if (server && client) {
        server.forEach(b => {
          let idx = client.findIndex(c => comp(b, c))
          if (idx === -1) {
            //delete
            arr.push(Object.assign({
              action: 3
            }, b))
          }
        })
      }
      if (client && server) {
        client.forEach(b => {
          let idx = server.findIndex(s => comp(s, b))
          if (idx === -1) {
            //insert
            arr.push(Object.assign({
              action: 1
            }, b))
          }
          else if (diff) {
            if (diff(server[idx], b)) {
              //update
              arr.push(Object.assign({
                action: 2
              }, b))
            }
          }
        })
      }
      return arr
    },
    cancel () {
      this.form.parameterList = this.clone(this.parameterList)
    },
    save () {
      this.$nextTick().then(() => {
        this.$refs.form.validate(valid => {
          if (valid) {
            let parameterList = this.makeDiff(this.parameterList, this.form.parameterList, (param1, param2) => param1.id === param2.id, (param1, param2) => param1.paramValue !== param2.paramValue)
            if (parameterList.length) {
              this.$refs.spinner.show()

              let cond = {
                functionId: 'setCreditControl',
                parameterList: parameterList
              }

              this.$tango.getFunctionData(cond).then(rep => {
                this.$refs.spinner.hide()
                if (rep.resultCode === 0) {
                  this.$message({
                    message: 'Set Credit Control Config success',
                    type: 'success'
                  })
                  this.forceLoading = !this.forceLoading
                }
                else {
                  this.cancel()
                  this.$message({
                    message: 'Error set config',
                    type: 'error'
                  })
                }
              }).catch(() => {
                this.$refs.spinner.hide()
              })
            }
          }
        })
      })
    },
    clone: function (data) {
      if (Array.isArray(data)) {
        let ret = []
        for (let i = 0; i < data.length; i++) {
          this.$set(ret, i, this.clone(data[i]))
        }
        return ret
      }
      else if (typeof data === 'object') {
        let ret = {}
        for (let k in data) {
          this.$set(ret, k, this.clone(data[k]))
        }
        return ret
      }
      else return data
    }
  },
  computed: {
    ...mapGetters([ 'instrumentList' ])
  },
  asyncComputed: {
    creditControlConfig: {
      get () {
        this.forceLoading = !this.forceLoading
        let cond = {
          functionId: 'getCreditControl'
        }
        return this.$tango.getFunctionData(cond).then(rep => {
          if (rep.resultCode !== 0) {
            throw new Error('ERROR : Credit Control Config')
          } else {
            if (rep.parameterList && rep.parameterList.length) {
              this.parameterList = rep.parameterList
              this.form.parameterList = this.clone(rep.parameterList)
            } else {
              this.parameterList = []
              this.form.parameterList = []
            }
          }
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
      },
      default: {}
    }
  }
}
</script>

<style lang='scss'>
.title {
  font-size: 1.3em;
  padding: 10px 0;
}

.tab-container {
  .el-form-item {
    width: 300px;
  }
}
</style>

